import React from 'react'
import './css/Whychoose.css'
import bed from "../assets/bed.svg"
import rightarrow from "../assets/rightsvg.svg"

const Whychoose = () => {
    const data = [
        { img: rightarrow, content: "Master craftsmanship with generations of woodworking expertise" },
        { img: rightarrow, content: "Premium quality hardwoods and sustainable materials" },
        { img: rightarrow, content: "Custom designs tailored to your specific requirements" },
        { img: rightarrow, content: "Traditional techniques combined with modern technology" },
        { img: rightarrow, content: "Timely delivery and professional installation" },
        { img: rightarrow, content: "Exceptional finishing and attention to detail" }
    ];
   
    return (
        <section className='main-div2'>
            <div className='main-div2-content1'>
                <div className='main-div2-content1-content1'>
                    <div className='main-div2-content1-content1-content1'>
                        <h2 className='whyy-choose-heading'> . Excellence in Woodworking</h2>
                        <p className='paragraph'>
                            At Dhiman Wood Works, we pride ourselves on delivering exceptional craftsmanship in every project. Our master craftsmen work closely with clients from initial design to final installation, ensuring each piece perfectly matches their vision and exceeds expectations. With decades of experience in fine woodworking, we bring unparalleled expertise to every custom creation.
                        </p>
                    </div>
                    <div className='circle-image'>
                        <img src={bed} alt="Woodworking Craftsmanship" />
                    </div>
                </div>
                <div className='main-div2-content1-content2'>
                    <div className='content-left'>
                        {data.slice(0, 3).map((item, index) => (
                            <div key={index} className='content-item'>
                                <img src={item.img} alt="feature" />
                                <p>{item.content}</p>
                            </div>
                        ))}
                    </div>
                    <div className='content-right'>
                        {data.slice(3, 6).map((item, index) => (
                            <div key={index} className='content-item'>
                                <img src={item.img} alt="feature" />
                                <p>{item.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Whychoose
